import React, { Component } from 'react';
import Big3Common from "../../js/Big3Common";
/* 개발담당:양유빈
 * 화면기능:상품사진 포토 공통
 * 세부설명:
*/

export class GoodsPhoto extends Component {
    static displayName = GoodsPhoto.name;

    constructor(props) {
        super(props);
        this.state = {
        };
    }
    //초기화
    componentDidMount() {
      
    }
    
    render() {
        const VirtualRoot = Big3Common.WebConfig.GoodsImageVirtualPath();
        let className = "";
        let ImageSrc = "";
        let totalCount = "";
        let BackGround = true;
        if (this.props.className !== undefined && this.props.className !== null) {
            className = this.props.className;
        }
        if (this.props.ImageSrc !== undefined && this.props.ImageSrc !== null) {
            ImageSrc = this.props.ImageSrc;
        }
        if (this.props.TotalCount !== undefined && this.TotalCount !== null) {
            totalCount = this.props.TotalCount;
        }
        if (this.props.BackGround !== undefined) {
            BackGround = this.props.BackGround;
        }
        if (ImageSrc !== "") {
            if (BackGround === true) {
                return (
                    <>
                        <div className={className} style={{ backgroundImage: `url(${VirtualRoot}${ImageSrc})` }}>{totalCount}</div>
                    </>
                );
            }
            else {
                return (
                    <div className={className}>
                        <div className="swiper-zoom-container">
                            <img src={VirtualRoot + ImageSrc} alt="상품사진" />
                        </div>
                        {totalCount}
                    </div>
                )
            }
        }
        else {
            return (
                <>
                    <div className={className}></div>
                </>
            );
        }
        
    }
}
